/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( document ).on( 'click', '.faculty-results .blog__pagination button', function() {
        filterResults( getFacultyFilters( $( this ).attr( 'data-value' ) ) );
      } );

      $( document ).on( 'change', 'select', function() {
        filterResults( getFacultyFilters() );
      } );

      $( document ).on( 'submit', 'form', function( e ) {
        e.preventDefault();
      } );

      $( document ).on( 'click', '.clear-filters', function() {
        $( 'select' ).val( '' );
        filterResults( getFacultyFilters() );
      } );

      function getFacultyFilters( paged = 1 ) {
        $( '.clear-filters-wrapper' ).addClass( 'hidden' );

        const args = {
          paged: paged,
        };

        if ( $( 'select[name="ll_faculty_program"]' ).val().length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );

          args.ll_faculty_program = $( '[name="ll_faculty_program"]' ).val();
        }

        if ( $( 'select[name="faculty_member_last_name"]' ).val().length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );

          args.meta_query = [
            {
              key: 'faculty_member_last_name',
              value: $( '[name="faculty_member_last_name"]' ).val(),
            },
          ];
        }

        return args;
      }

      function filterResults( args = [] ) {
        $( '.filter-results, .filter-form' ).addClass( 'is-loading' );

        const data = {
          'args': args,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/faculty/filter', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '.filter-results' ).html( data.results );
            $( '.filter-results, .filter-form' ).removeClass( 'is-loading' );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'faculty', COMPONENT );
} )( app );
